module.exports = __webpack_public_path__ + "static/nutrition_body_layout-412d87b83d0189b00cea58a003ab1da3.png";